import * as Yup from 'yup';

export const locationSchema = Yup.object().shape({

    name: Yup.string().required("Please enter name"),
    address: Yup.string().required("Please enter name"),
    email: Yup.string().email("Please enter a valid email")
})
